<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5><b>{{$t('Upgles.Edit.Heading')}}</b></h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field" id="AC">
                            <label for="title2" id="AC2">{{$t('Upgles.Edit.Active')}}</label>
                            <InputSwitch v-model="mydata.status" trueValue="active" />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Upgles.Edit.Type')}}</label>
                            <InputText type="text" :class="`${error.sub_type ? 'p-invalid' : ''}`" placeholder="Type" id="title2" v-model="mydata.sub_type"></InputText>
                            <div class="text-red">{{ error.sub_type }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Upgles.Edit.Days')}}</label>
                            <InputText type="text" :class="`${error.validity_date ? 'p-invalid' : ''}`" placeholder="Days" id="title2" v-model="mydata.validity_date"></InputText>
                            <div class="text-red">{{ error.validity_date }}</div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{$t('Upgles.Edit.OriginalPrice')}}</label>
                            <InputText type="text" :class="`${error.original_price ? 'p-invalid' : ''}`" placeholder="Original price" id="title2" @change="getpercentage" v-model="mydata.original_price"></InputText>
                            <div class="text-red">{{ error.original_price }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{$t('Upgles.Edit.DiscountRate')}}</label>
                            <InputText type="text" :class="`${error.discount ? 'p-invalid' : ''}`" placeholder="Discount rate (in percentage)" id="title2" @change="getpercentage" v-model="mydata.discount"></InputText>
                            <div class="text-red">{{ error.discount }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Upgles.Edit.Offeredprice')}}</label>
                            <InputText type="text" :class="`${error.discounted_price ? 'p-invalid' : ''}`" placeholder="Offered price" id="title2" v-model="mydata.discounted_price" disabled></InputText>
                            <!-- <div class="text-red">{{ error.discounted_price }}</div> -->
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Upgles.Edit.Save')" icon="pi pi-check" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('Upgles.Edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black;"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>
<script>
// import validateEditUser from '../../validations/user/validateEditUser';
import validateEditUpgle from '../../../validations/Upgle/validateEditUpgle';
import UpgleService from '../../../service/API/UpgleService';
import moment from 'moment';
export default {
    data() {
        return {
            dropdownValues: [{ name: 'active' }, { name: 'inactive' }],
            dropdownItem: null,
            // modelname: JSON.parse(localStorage.getItem('desc')).description,

            mydata: {
                sub_type_id: '',
                sub_type: '',
                validity_date: '',
                discount: '',
                original_price: '',
                discounted_price: '',
                no_of_cases: '2',
                status: '',
                
            },
            error: {},
        };
    },
    created() {
        this.upgleService = new UpgleService();
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        cancel() {
            // this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        SubmitForm() {},
        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    let vcheckData = {
                        sub_type: this.mydata.sub_type,
                        validity_date: this.mydata.validity_date,
                        original_price: this.mydata.original_price,
                        discount: this.mydata.discount,
                        // discounted_price: this.mydata.discounted_price,
                        no_of_cases: this.mydata.no_of_cases,

                        //     status: this.status ? 'active' : 'inactive',
                        //     file: this.image == '' ? '' : 'something',
                    };
                    const { isInvalid, error } = validateEditUpgle(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                    this.upgleService.editUpgle({ sub_type_id: this.$route.params.sub_type_id, sub_type: this.mydata.sub_type, validity_date: this.mydata.validity_date, discount: this.mydata.discount,original_price: this.mydata.original_price, discounted_price: this.mydata.discounted_price, no_of_cases: this.mydata.no_of_cases,status: this.mydata.status == 'active' ? 'active' : 'inactive'}).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'Upgle' });
                        setTimeout(() => {
                            this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '업글 정보가 저장되었습니다.', life: 3000 });
                        }, 500);
                    });
                }
                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        getpercentage() {
            if (this.mydata.original_price && this.mydata.discount) {
                this.mydata.discounted_price = (this.mydata.original_price - (this.mydata.discount / 100) * this.mydata.original_price);
            }
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
    },
    mounted() {
        this.upgleService.viewUpgle(this.$route.params.sub_type_id).then((res) => {
            this.mydata.status = res[0].status;
            this.mydata.original_price = res[0].original_price;
            this.mydata.discount = res[0].discount;
            this.mydata.discounted_price = res[0].discounted_price;
            this.mydata.sub_type = res[0].sub_type;
            this.mydata.validity_date = res[0].validity_date;
            console.log(res);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
div#AC {
    display: flex;
}
label#AC2 {
    margin-right: 12px;
}
#Save{
background: black;color: white;
}
</style>
